module.exports = __webpack_public_path__ + "static/media/DapperLabs.2bb55927.png";